const genControlHeight = token => {
  const {
    controlHeight
  } = token;
  return {
    controlHeightXS: controlHeight * 0.5,
    // Dui start
    controlHeightSM: controlHeight * 0.8,
    controlHeightLG: controlHeight * 1.2,
    controlHeightXL: controlHeight * 1.4
    // Dui end
  };
};
export default genControlHeight;